var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "svg",
      {
        staticClass: "screenfull-svg",
        attrs: {
          t: "1508738709248",
          viewBox: "0 0 128 128",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "2069",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          width: "128px",
          height: "128px"
        },
        on: { click: _vm.click }
      },
      [
        _c("g", [
          _c("path", {
            attrs: {
              fill: "#409EFF",
              stroke: "#409EFF",
              "stroke-miterlimit": "10",
              d:
                "M125.178,54.454c-1.921-4.466-4.76-8.383-8.298-11.443\n\t\t\tc-3.534-3.007-7.708-4.985-12.13-5.75c-1.557-0.282-3.132-0.426-4.708-0.429c-6.13,0-11.093,5.441-11.093,12.15v36.465\n\t\t\tc0,6.709,4.963,12.148,11.093,12.148c15.3,0,27.704-13.599,27.704-30.371C127.746,62.813,126.869,58.456,125.178,54.454z\n      M100.042,91.525c-3.06,0.007-5.541-2.707-5.546-6.061c0-0.006,0-0.014,0-0.02V48.981c0-3.354,2.477-6.071,5.546-6.071\n\t\t\tc12.244-0.272,22.372,10.391,22.621,23.816c0.247,13.424-9.479,24.526-21.724,24.799\n\t\t\tC100.641,91.534,100.341,91.534,100.042,91.525z"
            }
          }),
          _c("path", {
            attrs: {
              fill: "#2F3133",
              stroke: "#2F3133",
              "stroke-miterlimit": "10",
              d:
                "M36.701,15.024c5.666-4.006,12.009-6.723,18.652-7.988\n\t\t\tc9.534-1.796,19.338-0.43,28.161,3.924c7.995,3.874,15.955,11.132,21.848,19.95c0.933,1.392,2.72,1.692,3.988,0.669\n\t\t\tc1.271-1.024,1.543-2.981,0.61-4.374C103.493,17.53,94.688,9.522,85.809,5.229C75.955,0.372,65.005-1.147,54.36,0.866\n\t\t\tc-7.446,1.416-14.553,4.473-20.892,8.986c-5.077,3.667-9.595,8.189-13.387,13.399c-6.621,9.037-9.162,17.254-9.271,17.604\n\t\t\tc-0.236,0.795-0.177,1.659,0.164,2.406c-6.763,5.735-10.721,14.58-10.72,23.953C0.26,80.009,7.585,91.43,18.568,95.761\n\t\t\tc8.724,13.81,22.281,23.032,37.44,25.47c1.145,4.86,5.666,7.778,10.098,6.523c3.687-1.045,6.248-4.706,6.215-8.88\n\t\t\tc-0.022-5.034-3.764-9.097-8.356-9.073c-3.236,0.018-6.17,2.094-7.52,5.32c-11.414-1.912-21.862-8.132-29.543-17.583\n\t\t\tc0.355,0.021,0.71,0.058,1.075,0.058c6.12,0,11.083-5.439,11.083-12.148V48.981c0-6.709-4.963-12.15-11.083-12.15\n\t\t\tc-3.204,0.003-6.381,0.621-9.39,1.827c-0.284,0.1-0.565,0.204-0.847,0.31c1.312-3.006,3.543-7.389,6.93-11.972\n\t\t\tC28.079,22.333,32.14,18.293,36.701,15.024z M64.004,115.83c1.535,0.134,2.678,1.609,2.553,3.293\n\t\t\tc-0.109,1.49-1.191,2.676-2.553,2.796c-1.534-0.135-2.677-1.606-2.552-3.291C61.562,117.136,62.644,115.951,64.004,115.83z\n      M27.977,42.911c3.06,0,5.537,2.717,5.537,6.071v36.465c0,3.352-2.479,6.07-5.537,6.07C15.734,91.902,5.524,81.333,5.174,67.91\n\t\t\tc-0.351-13.421,9.289-24.614,21.532-25C27.128,42.898,27.553,42.898,27.977,42.911z"
            }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }